// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__xw-Ti","col":"styles_col__XV43R"};